import React, { useEffect, useState } from "react"
import { getUserPerformance,} from "../services/userService";
import { getCompanyUsers } from "../services/companyService";
export default function UserReportsPage() {
const [users, setUsers] = useState([]);
const [selectedUserId, setSelectedUserId] = useState("");

const [performance, setPerformance] = useState(null);

const [loadingUsers, setLoadingUsers] = useState(true);
const [loadingReport, setLoadingReport] = useState(false);

const [error, setError] = useState("");

/* ===================================================== /
/ LOAD USERS                                            /
/ ===================================================== */

useEffect(() => {
let cancelled = false;
(async () => {
  try {
    setLoadingUsers(true);
    setError("");

    const companyUsers =
         await getCompanyUsers();
    if (cancelled) return;

    setUsers(
      Array.isArray(companyUsers)
        ? companyUsers
        : []
    );

    if (
      Array.isArray(companyUsers) &&
      companyUsers.length > 0
    ) {
      setSelectedUserId(companyUsers[0]._id);
    }

  } catch (err) {
    if (!cancelled) {
      setError(
        err?.message ||
          "Failed to load users"
      );
    }
  } finally {
    if (!cancelled) {
      setLoadingUsers(false);
    }
  }
})();

return () => {
  cancelled = true;
};
}, []);

/* ===================================================== /
/ LOAD PERFORMANCE                                      /
/ ===================================================== */

useEffect(() => {
if (!selectedUserId) return;
let cancelled = false;

(async () => {
  try {
    setLoadingReport(true);
    setError("");

    const report =
      await getUserPerformance(
        selectedUserId
      );

    if (cancelled) return;

    setPerformance(report);

  } catch (err) {
    if (!cancelled) {
      setError(
        err?.message ||
          "Failed to load report"
      );
    }
  } finally {
    if (!cancelled) {
      setLoadingReport(false);
    }
  }
})();

return () => {
  cancelled = true;
};
}, [selectedUserId]);

/* ===================================================== /
/ CARD                                                  /
/ ===================================================== */

const MetricCard = ({
  title,
  value,
}) => {
  return (
    <div className="rounded-xl border bg-white p-5">
      <div className="text-sm text-gray-500">
        {title}
      </div>

      <div className="mt-2 text-3xl font-semibold text-gray-900">
        {value}
      </div>
    </div>
  );
};

/* ===================================================== /
/ UI                                                    /
/ ===================================================== */

return (
  <div className="max-w-7xl mx-auto p-6">

    <div className="mb-6">
      <h1 className="text-3xl font-semibold text-gray-900">
        User Reports
      </h1>

      <p className="text-gray-500 mt-1">
        Track productivity and task completion
        performance of team members.
      </p>
    </div>

    {/* USER SELECTOR */}

    <div className="mb-6">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Select User
      </label>

      <select
        value={selectedUserId}
        onChange={(e) =>
          setSelectedUserId(e.target.value)
        }
        className="
          w-full
          max-w-md
          rounded-xl
          border
          border-gray-300
          px-4
          py-3
        "
      >
        <option value="">
          Select User
        </option>

        {users.map((user) => (
          <option
            key={user._id}
            value={user._id}
          >
            {user.name}
          </option>
        ))}
      </select>
    </div>

    {/* ERROR */}

    {error && (
      <div className="mb-6 rounded-xl bg-red-50 p-4 text-red-600">
        {error}
      </div>
    )}

    {/* LOADING */}

    {(loadingUsers || loadingReport) && (
      <div className="rounded-xl border bg-white p-6">
        Loading report...
      </div>
    )}

    {/* REPORT */}

    {!loadingReport &&
      performance && (
        <div className="grid gap-4 md:grid-cols-3">

          <MetricCard
            title="Assigned Tasks"
            value={performance.assignedTasks}
          />

          <MetricCard
            title="Completed Tasks"
            value={performance.completedTasks}
          />

          <MetricCard
            title="Active Tasks"
            value={performance.activeTasks}
          />

          <MetricCard
            title="Overdue Tasks"
            value={performance.overdueTasks}
          />

          <MetricCard
            title="Completed On Time"
            value={performance.completedOnTime}
          />

          <MetricCard
            title="Completed Late"
            value={performance.completedLate}
          />

          <MetricCard
            title="Completion Rate"
            value={`${performance.completionRate}%`}
          />

        </div>
      )}

  </div>
);
}